module.exports = __webpack_public_path__ + "static/media/tlyfe.9f278237.png";